<template>
<layout-content v-if="isShow">
  <template #headerTitle>
    <el-button
      icon="el-icon-back"
      size="small"
      style="float:left;"
      @click="onBackBtnClick"
    >返回上一级</el-button>

    <h1 class="layout-content-header-text" style="margin-left:.5em;">{{site.name}} / {{auditSiteDevice.name}} / 数据 {{numberToCN[stage]}} 审</h1>
  </template>

  <template #toolbar>
    <section class="toolbar-btn">
      <el-date-picker
        v-model="conditions.auditTime"
        type="date"
        format="yyyy年MM月dd日"
        value-format="yyyy/MM/dd"
        :clearable="false"
        :editable="false"
        size="small"
        style="width:170px;"
        @change="onAuditTimeChanged"
      />

      <el-button
        type="success"
        icon="el-icon-monitor"
        size="small"
        @click="onFullScreenBtnClick"
      >{{showSideNav ? '全屏' : '恢复'}}显示</el-button>

      <el-button
        v-if="hasAuditBtn"
        type="orange"
        icon="el-icon-edit-outline"
        size="small"
        @click="onAuditSubmitBtnClick"
      >提交{{stage >= maxAuditStage ? '终' : numberToCN[stage + 1]}}审</el-button>

      <el-button
        v-if="hasAuditBtn && stage > 1"
        type="warning"
        icon="el-icon-close"
        size="small"
        @click="onBackReAuditBtnClick"
      >退回重审</el-button>

      <el-button
        v-if="!hasAuditBtn && isAdmin && stage >= maxAuditStage && (auditSiteDevice || {}).auditStage >= (1 << maxAuditStage)"
        type="warning"
        icon="el-icon-close"
        size="small"
        @click="onBackAuditedBtnClick"
      >退回重审</el-button>
    </section>
  </template>

  <template #body>
    <section class="audit-content">
      <section class="audit-content-inner">
        <div>
          <lidar-chart-wrapper
            @lidar-chart-ready="onLidarChartReady"
            @lidar-chart-destroy="onLidarChartDestroy"
          />
        </div>

        <section class="audit-table-wrapper">
          <div>
            <audit-operator-btn-group3-d
              ref="auditOperator"
              :model="auditModel"
              :disabled="selectedDataTimes.length === 0"
              @change="onAuditChanged"
            />
          </div>
          <div>
            <el-table
              ref="table"
              :data="auditList"
              border
              stripe
              highlight-current-row
              header-row-class-name="custom-table-header"
              height="100%"
              class="custom-table no-inner-border"
              style="width: 100%"
              @row-click="onTableRowClick"
              @select="onDataSelect"
              @select-all="onAllDataSelect"
            >
              <el-table-column type="selection" width="38" />
              <el-table-column label="时间" prop="dataTime">
                <template slot-scope="{row}">
                  <div class="audit-operator-type" :flag="row.auditFlag">
                    <div>{{row.dataTime}}</div>
                    <div v-if="row.auditFlag">{{row.auditComment}}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </section>
    </section>
  </template>
</layout-content>
</template>

<script>
import BaseAuditDevice from './BaseAuditDevice'
import LidarChartWrapper from '../../../components/Data/ChartWrapper/LidarChartWrapper'
import {LIDAR_DATA_LIST_CHANGED, LIDAR_DATA_SELECT} from '../../../components/Data/ChartWrapper/EventKeys'
import AuditOperatorBtnGroup3D from './AuditOperatorBtnGroup3D'
import {mapGetters} from 'vuex'

export default {
  name: 'AuditParticleSizeSpectrumDevice',
  extends: BaseAuditDevice,
  components: {AuditOperatorBtnGroup3D, LidarChartWrapper},
  data () {
    return {
      chartOpts: {
        legendMinVal: 0,
        legendMaxVal: 1000
      },
      auditList: [],
      auditModel: {
        operatorType: 0,
        comment: ''
      },
      selectedDataTimes: Object.freeze([])
    }
  },
  computed: {
    ...mapGetters({
      showSideNav: 'Profile/showSideNav'
    }),
    siteDeviceCategory: () => process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY,
    auditMap () {
      return this.auditList.reduce((map, audit) => {
        map[audit.dataTime] = audit
        return map
      }, {})
    }
  },
  methods: {
    onLidarChartReady (lidarEB) {
      this.lidarEB = lidarEB
    },
    onLidarChartDestroy () {
      this.lidarEB = null
    },
    onTableRowClick (row) {
      this.lidarEB.$emit(LIDAR_DATA_SELECT, row.dataTime)
    },
    onAuditSubmitBtnClick () {
      this.submitAudit()
    },
    formatDataList (data) {
      this.heights = this.getFormatHeights(data.height)
      this.dataList = Object.freeze(this.getFormatDataList(data.data))
      this.auditList = this.dataList.map(data => ({
        dataTime: data.dataTime,
        auditFlag: data.auditFlag,
        auditComment: data.auditComment
      }))
      this.renderChart()
    },
    getFormatHeights (heightStr) {
      return heightStr.split('|').map(height => Number(height))
    },
    getFormatDataList (dataList) {
      return dataList.map(data => ({
        dataTime: data.dataTime,
        value: data.dasValue.split('|').map(value => value === '' ? null : Number(value)),
        auditFlag: data.auditFlag,
        auditComment: data.auditComment
      }))
    },
    renderChart () {
      let {dataList} = this

      if (!Array.isArray(dataList)) {
        return
      }

      let {auditSiteDevice, heights, conditions: {auditTime}, chartOpts} = this
      let beginTime = new Date(auditTime)
      beginTime.setHours(process.env.AUDIT_BEGIN_HOUR, 0, 0)
      let endTime = new Date(beginTime)
      endTime.setHours(endTime.getHours() + 24)
      chartOpts.minHeight = heights[0]
      chartOpts.maxHeight = heights[heights.length - 1]

      for (let key in chartOpts) {
        chartOpts[key] = Number(chartOpts[key])
      }

      this.lidarEB.$emit(LIDAR_DATA_LIST_CHANGED, {
        id: auditSiteDevice.id,
        name: auditSiteDevice.name,
        heights,
        values: dataList,
        dataFrequency: auditSiteDevice.dataFrequency,
        beginTime,
        endTime,
        colors: [[0, 0, 255], [0, 255, 255], [0, 255, 0], [255, 255, 0], [255, 0, 0]],
        yAxisName: ' ',
        yAxisUnit: ' ',
        ...chartOpts
      })
    },
    onDataSelect (selection) {
      this.selectedDataTimes = Object.freeze(selection.map(row => row.dataTime))
    },
    onAllDataSelect (selection) {
      this.selectedDataTimes = Object.freeze(selection.map(row => row.dataTime))
    },
    onAuditChanged () {
      let {auditModel} = this

      this.changeLoadStatus(true)

      let {operatorType, comment} = auditModel

      this.$api.Audit.updateAuditFlag({
        siteDeviceId: this.auditSiteDevice.id,
        auditFlag: operatorType,
        auditComment: comment,
        dataTimes: this.selectedDataTimes
      }).then(data => {
        if (data) {
          let {auditMap} = this

          this.selectedDataTimes.forEach(dataTime => {
            let audit = auditMap[dataTime]
            audit.auditFlag = operatorType
            audit.auditComment = comment
          })

          this.$refs.table.clearSelection()
        }
      }).catch(console.error).finally(() => {
        operatorType = comment = null
        this.changeLoadStatus(false)
      })
    },
    onFullScreenBtnClick () {
      this.$store.commit('Profile/showSideNav', !this.showSideNav)
      setTimeout(() => {
        let event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-content {
  width: 100%;
  height: 100%;
  padding: 10px 1em 0;

  > .audit-content-inner {
    display: grid;
    grid-template-columns: auto 240px;
    grid-column-gap: 20px;
    width: 100%;
    height: 100%;
    overflow: auto;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .audit-table-wrapper {
      display: grid;
      grid-template-rows: max-content auto;
      grid-row-gap: 10px;

      > * {
        min: {
          width: 0;
          height: 0;
        }
      }
    }

    .audit-operator-type {
      &[flag="RESERVE"] {
        color: #67C23A;
      }

      &[flag="DELETE"] {
        color: #F56C6C;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditParticleSizeSpectrumDevice.vue